import { createSlice } from '@reduxjs/toolkit';
import { StoreName } from 'app/enums/store';

import { registerReducers } from './repository';
import { initialState } from './adapter';
import * as reducers from './reducers';

export const sessionState = createSlice({
  name: StoreName.Session,
  initialState,
  reducers: {
    setRedirect: reducers.setRedirectReducer,
    setIsChatPinned: reducers.setIsChatPinnedReducer,
    setIsLeaderboardExpanded: reducers.setIsLeaderboardExpandedReducer,
    setTournamentFilter: reducers.setTournamentFilterReducer,
    setMatchFilter: reducers.setMatchFilterReducer,
    resetState: reducers.resetStateReducer,
  },
  extraReducers: (builder) => registerReducers(builder),
});

export const sessionReducers = { ...sessionState.actions };
